import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";

import {fetchDocuments,} from '../redux/slices/documentSlice';
// import "../css/kycformnew.css";
import "../pages/NewEmployeeKyc.css"; // Assuming this is the path to the styles file
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function EmployeeKyc() {
  const dispatch = useDispatch();
  const { employeeReport } = useSelector((state) => state.employee);


    const { documents = [],  error } = useSelector(state => state.documents || {});
  

  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocType, setSelectedDocType] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [previewImage, setPreviewImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const superAdminId = localStorage.getItem("adminuserId") || "12";
  const documentTypes = ["Aadhar Card", "PAN Card", "Photo", "Other"];
  const fileInputRef = useRef(null);

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: currentPage, superAdminId }));
  }, [dispatch, currentPage, superAdminId]);



  useEffect(() => {
  const superAdminId = localStorage.getItem("adminuserId");
  dispatch(fetchDocuments({ serviceId: superAdminId, description: "Employe" }));
}, [dispatch]);


  const handleSearch = async () => {
    if (!filterValue?.trim()) {
      return toast.warn("Please enter a value to search.");
    }

    let query = { superAdminId };

    switch (filterType) {
      case "Employee id":
        query.userId = filterValue.trim();
        break;
      case "pan":
        query.panNumber = filterValue.trim();
        break;
      case "aadhaar":
        query.aadhaarNumber = filterValue.trim();
        break;
      case "mobile":
        query.mobileNumber = filterValue.trim();
        break;
      default:
        return toast.warn("Unsupported filter type.");
    }

    try {
      setLoading(true);
      const response = await axios.get("https://narrowitsolution.in/api/get-employ-filter", { params: query });

      if (response.data?.status === false || !response.data?.data) {
        setSelectedEmployee(null);
        setUploadedKyc([]);
        return toast.info(response.data?.message || "Employee not found.");
      }

      const emp = response.data.data;

      setSelectedEmployee({
        userId: emp.userId,
        name: emp.fullName,
        pan: emp.panNumber,
        aadhaar: emp.aadhaarNumber,
        mobile: emp.mobileNumber,
        dob: emp.dateOfBirth?.slice(0, 10),
      });

      const kycResponse = await axios.get("https://narrowitsolution.in/api/list-employee-kyc", {
        params: { userId: emp.userId, superAdminId },
      });

      setUploadedKyc(kycResponse.data.documents || []);
    } catch (err) {
      console.error(err);
      setSelectedEmployee(null);
      setUploadedKyc([]);
      toast.error("Failed to fetch employee or KYC. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async () => {
    if (!selectedEmployee) return toast.warn("Search and select employee first.");
    if (!selectedFile || !selectedDocType) return toast.warn("Select document type and file.");

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("userId", selectedEmployee.userId);
      formData.append("superAdminId", superAdminId);
      formData.append("docName", selectedDocType);
      formData.append("status", "pending");
      formData.append("createdId", superAdminId);

      await axios.post("https://narrowitsolution.in/api/create-employee-kyc", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Document uploaded successfully");

      setSelectedFile(null);
      setSelectedDocType("");
      if (fileInputRef.current) fileInputRef.current.value = "";

      const kycResponse = await axios.get("https://narrowitsolution.in/api/list-employee-kyc", {
        params: { userId: selectedEmployee.userId, superAdminId },
      });
      setUploadedKyc(kycResponse.data.documents || []);
    } catch (err) {
      console.error(err);
      toast.error("Document upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleAction = async (docId, action) => {
    try {
      const url =
        action === "approved"
          ? `https://narrowitsolution.in/api/approve-employee-kyc/${docId}`
          : `https://narrowitsolution.in/api/reject-employee-kyc/${docId}`;
      await axios.post(url);
      toast.success(`Document ${action}`);

      const kycResponse = await axios.get("https://narrowitsolution.in/api/list-employee-kyc", {
        params: { userId: selectedEmployee.userId, superAdminId },
      });
      setUploadedKyc(kycResponse.data.documents || []);
    } catch (err) {
      console.error(err);
      toast.error("Action failed");
    }
  };

  return (
    <div className="BranchLoanKycUpload-container-employee">
      {/* <ToastContainer /> */}
      <h1>Employee KYC Management</h1>

      {/* Search Employee */}
      <section className="header-section-employee">
        <h2>Search Employee</h2>
        <div className="search-controls-employee">
          <select value={filterType} onChange={(e) => { setFilterType(e.target.value); setFilterValue(""); }}>
            <option value="">Select Filter</option>
            <option value="Employee id">Employee ID</option>
            <option value="pan">PAN</option>
            <option value="aadhaar">Aadhaar</option>
            <option value="mobile">Mobile</option>
          </select>
          <input
            type="text"
            placeholder={`Enter ${filterType || "value"}`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
          />
          <button onClick={handleSearch} disabled={loading}>{loading ? "Searching..." : "Search"}</button>
        </div>
      </section>

    
     

      <div> 
          <section className="header-section-employee">
            <h2>Employee Details</h2>
            <table className="kyc-details-table">
              <tbody>
                <tr>
                  <th>User ID</th>
                  <td>{selectedEmployee?.userId || "-"}</td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{selectedEmployee?.name || "-"}</td>
                </tr>
                <tr>
                  <th>PAN</th>
                  <td>{selectedEmployee?.pan || "-"}</td>
                </tr>
                <tr>
                  <th>Aadhaar</th>
                  <td>{selectedEmployee?.aadhaar || "-"}</td>
                </tr>
                <tr>
                  <th>Mobile</th>
                  <td>{selectedEmployee?.mobile || "-"}</td>
                </tr>
                <tr>
                  <th>DOB</th>
                  <td>{selectedEmployee?.dob || "-"}</td>
                </tr>
              </tbody>
            </table>

            {!selectedEmployee && <p style={{ fontStyle: "italic" }}></p>}
          </section>
      </div>


      {/* Upload KYC */}
      <section className="header-section-employee">
        <h2 >Upload KYC</h2>
        <div className="upload-controls-employee">
      
        <select
          value={selectedDocType}
          onChange={(e) => setSelectedDocType(e.target.value)}
        >
          <option value="">Select Document Type</option>
          {documents.map((doc, idx) => (
            <option key={idx} value={doc.name}>
              {doc.name}
            </option>
          ))}
        </select>


        {documents.length === 0 && <p style={{ fontStyle: "italic" }}>No document types available</p>}

          <input
            ref={fileInputRef}
            type="file"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
          <button onClick={handleUpload} disabled={loading}>{loading ? "Uploading..." : "Upload"}</button>
        </div>
        {!selectedEmployee && <p style={{ fontStyle: "italic" }}></p>}
      </section>



      {/* Employee KYC Documents (Now wrapped for scrolling) */}
      <section className="header-section-employee">
        <h2>Employee KYC Documents</h2>
        {/* WRAPPER ADDED FOR HORIZONTAL SCROLLING ON MOBILE */}
        <div className="kyc-document-table-wrapper">
          <table className="kyc-table-employee">
              <thead>
            <tr>
              <th>#</th>
              <th>Document</th>
              <th>Status</th>
              <th>Preview</th>
              <th>Action</th>
            </tr>
              </thead>
              <tbody>
            {uploadedKyc.length > 0 ? (
              uploadedKyc.map((doc, idx) => (
                <tr key={doc.id}>
                  <td>{idx + 1}</td>
                  <td>{doc.docName}</td>
                  <td>{doc.status}</td>
                  <td>
                    {doc.docImage ? (
                      <button
                        onClick={() => {
                          setPreviewImage(`https://narrowitsolution.in/uploads/${doc.docImage}`);
                          setIsModalOpen(true);
                        }}
                      >
                        View
                      </button>
                    ) : "N/A"}
                  </td>
                  <td>
                    <div className="employee-action-button">
                        <button className="employee-approve-button" onClick={() => handleAction(doc.id, "approved")}>✔ </button>
                        <button className="employee-reject-button" onClick={() => handleAction(doc.id, "rejected")}>X</button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", fontStyle: "italic" }}>No documents uploaded</td>
              </tr>
            )}
              </tbody>
            </table>
        </div>
      </section>

      {/* Image Preview Modal */}
      {isModalOpen && (
        <div className="modal-overlay-employee" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content-employee" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="Preview" />
            <button className="close-btn" onClick={() => setIsModalOpen(false)}>✖</button>
          </div>
        </div>
      )}
    </div>
  );
}